// Localized lookup for injury names (defaultInjuries.ts in worker).
//
// Worker stores `injury.type` as the English string ("Sprained Ankle" etc.)
// in the league DB. UI translates by looking up the value as a key under the
// `injury.*` namespace. Unknown values (custom injuries or
// future additions) pass through unchanged.
import i18n from "./i18n.ts";

export const translateInjuryName = (name: string): string => {
	if (!i18n.isInitialized || !name) return name;
	const t = i18n.t(`injury.${name}`, { ns: "ui", defaultValue: name });
	return typeof t === "string" && t.length > 0 ? t : name;
};
